import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { useApi } from '@fortem-monorepo/react-spa'
import { MonthlyRoll } from '@fortem-monorepo/web-sdk'

import { useUserContext } from '@/index'

export const useSendMonthlyRollEmailMutation = () => {
  const api = useApi()

  const { loggedInUser } = useUserContext()

  return useMutation({
    mutationFn: (params: MonthlyRoll.GetMonthlyRollParams) => api.monthlyRoll.sendEmail(params),
    onSuccess: () => {
      toast.success(`Monthly roll email sent to ${loggedInUser.user?.email}`)
    },
  })
}
